// extracted by mini-css-extract-plugin
export default {"row":"ThirdScreen_row__350f0","title":"ThirdScreen_title__LFW4K"};